import { httpCreator } from "./httpCreator";

const BASE_URL = import.meta.env.REACT_APP_API;

const httpClient = httpCreator(BASE_URL as string);

export { httpClient };
